import { IncomingHttpHeaders } from 'http';
import { apiClient } from '@doda/api-client/util/apiClient';
import { Methods as NearAreaAPI } from '@doda/api-client/aspida/api/v1/jobs/neararea';
import { NearAreaResponse } from '@doda/api-client/aspida/@types';
import { getAccessToken } from './getAccessToken';

export type NearAreaQuery = NonNullable<NearAreaAPI['get']['query']>;
export const NEAR_AREA_DISPLAY_NUMBER = 5;

interface NearAreaV2Options {
  isNearAreaV2?: boolean;
  limitDefault: number;
}

/**
 * 近隣エリアAPIへのリクエスト
 * @param {NearAreaQuery} query
 * @param {NearAreaV2Options} options 近隣エリアV2用設定
 * @param {IncomingHttpHeaders} headers
 * @return {NearAreaResponse} 近隣エリアの求人一覧
 */
export const getNearAreaJobList = async (
  query: NearAreaQuery,
  options: NearAreaV2Options,
  headers?: IncomingHttpHeaders
): Promise<NearAreaResponse> => {
  if (!options.isNearAreaV2) {
    return apiClient.api.v1.jobs.neararea.$get({
      query,
      config: { headers },
    });
  }

  const accessToken = await getAccessToken(headers);
  return apiClient.api.v2.jobs.neararea.$get({
    query: {
      ...query,
      limit: query.limit ?? options.limitDefault,
      offset: query.offset ?? 0,
    },
    config: {
      headers: {
        ...headers,
        ...(accessToken && { authorization: `Bearer ${accessToken}` }),
      },
    },
  });
};
